import { FeApi } from '../..';
import {
  type UnitStatus,
  type UnitStatusTrippedUnits,
} from '../../domain/entities/site-unit-status';

export function siteUnitStatusMapper(
  data: FeApi.SiteDetailViewOutputSerializerUnitStatus,
): UnitStatus {
  return {
    operational: data.operational,
    tripped: data.tripped.map(siteUnitStatusTrippedUnitsMapper),
  };
}

function siteUnitStatusTrippedUnitsMapper(
  data: FeApi.SiteDetailViewOutputSerializerUnitStatusTrippedUnits,
): UnitStatusTrippedUnits {
  return {
    frontendId: data.frontend_id,
    since: new Date(data.since),
  };
}
